<div>
  <label class="header-label" id="countryssearch2" for="hotel-pref-prop"
    >{{title | translate}}</label
  >
  <i class="ico-marker select-box-icon"></i>
  <select
    [(ngModel)]="country.cCode"
    appSelect
    name="location"
    id="hotel-pref-prop"
    aria-labelledby="countryssearch2"
  >
    @for (ctry of countries; track ctry) {
    <option [value]="ctry.cCode">{{ctry.cName}}</option>
    }
  </select>
</div>
